import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    text: '¿Quién autorizó ese cambio?',
    author: 'Nadie encontraba el mensaje'
  }, {
    text: 'Pasé 3 horas armando el informe semanal.',
    author: 'Constructor'
  }];
  return <section id="problema" className="scroll-mt-20 py-16 sm:py-24 bg-white" data-id="element-203">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-204">
        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="inline-block px-4 py-1.5 bg-blue-50 text-blue-600 text-xs font-bold uppercase tracking-wider rounded-full mb-6" data-id="element-205">
          EL PROBLEMA
        </motion.div>

        {/* Headline */}
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-[32px] sm:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-12 sm:mb-16 leading-[1.1] tracking-tight" data-id="element-206">
          Tu obra ya está documentada.{' '}
          <span className="text-blue-600" data-id="element-207">Solo se pierde.</span>
        </motion.h2>

        {/* Quote cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 text-left max-w-3xl mx-auto" data-id="element-208">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1 + index * 0.1
        }} className="relative bg-gray-50 border border-gray-200 rounded-2xl p-6 sm:p-8" data-id="element-209">
              <Quote className="w-5 h-5 sm:w-6 sm:h-6 text-blue-300 mb-3" data-id="element-210" />
              <p className="text-base sm:text-lg text-gray-900 font-medium leading-snug mb-4 sm:mb-5" data-id="element-211">
                "{problem.text}"
              </p>
              <p className="text-[11px] sm:text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-212">
                — {problem.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}